export default __webpack_public_path__ + "static/media/Marathi-letter-convnet.e666a1fd.png";